<template>
  <button
    :class="{ selected: type === currentType }"
    @click="emit('select', type)"
  >
    <span>{{ label }}</span>
    <div class="badge">
      <BadgeNotification theme="red" :count="count" />
    </div>
  </button>
</template>
<script setup lang="ts">
interface Props {
  currentType: 'all' | 'self' | 'following';
  type: 'all' | 'self' | 'following';
  label: string;
  count: number;
}
defineProps({
  currentType: null,
  type: null,
  label: null,
  count: null
});
const emit = defineEmits(["select"]);
</script>
<style lang="scss" scoped>
button {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 4rem;
  color: var(--color_neutral_900);
  text-align: center;
  @include font('n', 600, 'secondary');
  @include hover-focus-desktop {
    color: var(--color_secondary);
    &::after {
      transform: scale(1);
      opacity: 1;
    }
  }
  &.selected {
    color: var(--color_secondary);
    &::after {
      transform: scale(1);
      opacity: 1;
    }
  }
  &::after {
    content: '';
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.2rem;
    transform: scale(0);
    transition: transform 300ms $ease-out-quad;
    opacity: 0;
    background-color: var(--color_secondary);
  }
}
.badge {
  position: absolute;
  top: 0;
  right: -1.6rem;
  transform: scale(0.8);
  transition: transform 400ms $ease-out-back-custom;
  @include above('l') {
    right: -2.5rem;
  }
}
</style>
